/** add an item to session storage
@itemName { string } - name to use in the sessionStorage
@item { any } - item to be stored
@return { null }
*/
export const addItemToSessionStorage = (itemName, item) => {
    window.sessionStorage.setItem(itemName, JSON.stringify(item))
}

/** add an item to session storage
@itemName { string } - name to use in the sessionStorage
@item { any } - item to be stored
@return { null }
*/
export const addItemToLocalStorage = (itemName, item) => {
    window.localStorage.setItem(itemName, JSON.stringify(item))
}

/** add new info to an object that already exists in session storage
@itemName { string } - name of object we want to add info in sessionStorage
@item { any } - item to be stored to sessionStorage object
@return { null }
*/
export const addInfoToCurrentsessionStorageObjectItem = (itemName, item) => {
	const newSessionStorageInfo = { ...getItemFromSessionStorage(itemName), ...item }
	addItemToSessionStorage(itemName, newSessionStorageInfo)
}

/** remove item from session storage
@itemName { string } - name of the item in the sessionStorage
@return { null }
*/
export const removeItemFromSessionStorage = itemName => {
    window.sessionStorage.removeItem(itemName)
}

/** remove info from an an object in session storage
@itemName { string } - name of object we want to remove info in sessionStorage
@item { any } - key of info we want to remove from sessionStorage
@return { null }
*/
export const removeInfoFromCurrentSessionObjectItem = (itemName, item) => {
	const newSessionStorageInfo = getItemFromSessionStorage(itemName)
	if (newSessionStorageInfo) {
		delete newSessionStorageInfo[item]
		addItemToSessionStorage(itemName, newSessionStorageInfo)
	}
}

/** get an item from session storage
@itemName { string } - name of the item in the store
@return { item || undefined } - the parsed item or undefined
*/
export const getItemFromSessionStorage = itemName => {
    const item = window.sessionStorage.getItem(itemName)
    return item ? JSON.parse(item) : undefined
}

/** get an item from session storage
@itemName { string } - name of the item in the store
@return { item || undefined } - the parsed item or undefined
*/
export const getItemFromLocalStorage = itemName => {
    const item = window.localStorage.getItem(itemName)
    return item ? JSON.parse(item) : undefined
}

/** save current time to local storage
@date { string } - current date/time
@return { null }
*/
export const saveCurrentDateToLocalStorage = date => {
    window.localStorage.setItem('saved-date', date)
}
